import { useQuery } from 'react-query'
import { get } from 'framework/api/http'

/* Get all sample users */
export const getUserList = async (queryData: any) => {
  const { skip, take, Search } = queryData.queryKey[1]

  const res = await get(
    `UserProfile?take=${take}&skip=${skip}&Search=${Search}`,
  )

  return res.data
}

/* Use Query as a Hook */
export const useUserList = (queryData: any) => {
  return useQuery(['divisions', queryData], getUserList, {
    refetchOnWindowFocus: true,
  })
}
